import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import MaterialTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  memoTemplateListAllByApplicationType,
  removeMemoTemplateMutation,
} from '../../shared/queries/MemoTemplates';
import {
  TEMPLATE_APPLICATION_TYPE,
  TEMPLATE_TYPE_COMU,
  TEMPLATE_TYPE_OCCU,
} from '../../shared/utils/constants';

const MemoTemplate = (props) => {
  const { t, dispatch, history, type } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };
  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/template-${type}/mnt/${rowData.id}`);
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push(`/minime/template-${type}/mnt/0`);
  };

  const loadAllTemplateByType = (applicationType) => {
    showLoading();
    const query = memoTemplateListAllByApplicationType(applicationType);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.memoTemplateListByFilter) {
          res.memoTemplateListByFilter = res.memoTemplateListByFilter.map(
            (template) => ({
              ...template,
              activeDescription: t(`general.yesno.${template.active}`),
            })
          );
          setData(res.memoTemplateListByFilter);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadTemplateByType = () => {
    switch (type) {
      case TEMPLATE_TYPE_COMU:
        loadAllTemplateByType(TEMPLATE_APPLICATION_TYPE.COMU);
        break;
      case TEMPLATE_TYPE_OCCU:
        loadAllTemplateByType(TEMPLATE_APPLICATION_TYPE.OCCU);
        break;

      default:
        break;
    }
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const mutation = removeMemoTemplateMutation(selectedDto.id);
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        loadTemplateByType();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
        loadTemplateByType();
      });
  };

  useEffect(() => {
    loadTemplateByType();
  }, []);

  return (
    <>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    onRefreshClick={loadTemplateByType}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    deleteAction={toggleModal}
                    columns={columns(t)}
                    pageSize={20}
                    data={data}
                    title={t(`panels.template-${type}`)}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

MemoTemplate.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  type: PropTypes.string.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(MemoTemplate)
);
